/**
 * The value of a mailbox port box as the API wants it: a number, or `null`
 * when the box is blank so the organization-level setting applies.
 *
 * `NumberBox` hands back its raw text, so without this a port would reach the
 * API as `"995"`.
 */
export function toOptionalPort(text: string): number | null {
    const trimmed = text.trim();
    if (trimmed === "") {
        return null;
    }
    const port = parseInt(trimmed, 10);
    return Number.isNaN(port) ? null : port;
}
